export const TRANSLATION_SCOPE = 'imprintModule';
export const TRANSLATION_IMPRESS_SCOPE = [TRANSLATION_SCOPE, 'imprint'];
